var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.5 0h1v3.063A2 2 0 0 1 10 5v6a2 2 0 0 1-1.5 1.937V16h-1v-3.063A2 2 0 0 1 6 11V5a2 2 0 0 1 1.5-1.937zM7 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0zM2.5 3h-1v3.063A2 2 0 0 0 0 8v3a2 2 0 0 0 1.5 1.937V16h1v-3.063A2 2 0 0 0 4 11V8a2 2 0 0 0-1.5-1.937zM2 12a.996.996 0 0 0 1-1V8a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1m12.5-9h-1v3.063A2 2 0 0 0 12 8v3a2 2 0 0 0 1.5 1.937V16h1v-3.063A2 2 0 0 0 16 11V8a2 2 0 0 0-1.5-1.937zm-.5 9a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1",
  clipRule: "evenodd"
})));
export default SvgChartIcon;